export const phoneRegExp = /^[+\-()\d\s]{11,}$/;
export const validNameExp = /^[a-zа-яё\s]+$/iu;
